import type { TranslationMessages } from '../types';

export const cost_categories: TranslationMessages = {
  title: 'Danh mục chi phí',
  subtitle: 'Quản lý danh mục chi phí để tổ chức tốt hơn',
  new_category: 'Thêm danh mục',
  search_placeholder: 'Tìm kiếm danh mục...',
  no_results: 'Không tìm thấy danh mục',
  try_adjusting_search: 'Thử điều chỉnh tiêu chí tìm kiếm của bạn',
  add_first_category: 'Thêm danh mục đầu tiên',
  created: 'Đã tạo',
  default: 'Mặc định',
  custom: 'Tùy chỉnh',
  filter_categories: 'Lọc danh mục',
  default_status: 'Trạng thái mặc định',
  select_default_status: 'Chọn trạng thái mặc định',
  all_categories: 'Tất cả danh mục',
  default_categories: 'Danh mục mặc định',
  custom_categories: 'Danh mục tùy chỉnh',
  clear_all: 'Xóa tất cả',
  apply_filters: 'Áp dụng bộ lọc',
  no_permission_delete: 'Bạn không có quyền xóa danh mục chi phí.',
  delete_confirm: 'Bạn có chắc chắn muốn xóa danh mục này không?',
  delete_confirm_irreversible:
    'Bạn có chắc chắn muốn xóa danh mục này không? Hành động này không thể hoàn tác.',
  delete_error: 'Không thể xóa danh mục. Vui lòng thử lại.',
  create_title: 'Tạo danh mục chi phí',
  create_subtitle: 'Thêm danh mục chi phí mới để tổ chức tốt hơn',
  edit_title: 'Chỉnh sửa danh mục chi phí',
  edit_subtitle: 'Cập nhật thông tin danh mục',
  basic_information: 'Thông tin cơ bản',
  name_placeholder: 'Nhập tên danh mục...',
  name_required: 'Tên là bắt buộc',
  description_placeholder: 'Nhập mô tả danh mục...',
  description_required: 'Mô tả là bắt buộc',
  parent_placeholder: 'Nhập danh mục cha (tùy chọn)...',
  set_as_default: 'Đặt làm danh mục mặc định',
  summary: 'Tóm tắt',
  not_entered: 'Chưa nhập',
  none: 'Không có',
  yes: 'Có',
  no: 'Không',
  save_category: 'Lưu danh mục',
  update_category: 'Cập nhật danh mục',
  delete_category: 'Xóa danh mục',
  no_permission_create: 'Bạn không có quyền tạo danh mục chi phí.',
  no_permission_edit: 'Bạn không có quyền chỉnh sửa danh mục chi phí.',
  create_error: 'Không thể tạo danh mục chi phí. Vui lòng thử lại.',
  update_error: 'Không thể cập nhật danh mục chi phí. Vui lòng thử lại.',
  load_error: 'Không thể tải dữ liệu danh mục. Vui lòng thử lại.',
  categoryCreated: 'Tạo danh mục chi phí thành công',
};
